import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ControlValueAccessorMixin } from '../../../core/mixins/ControlValueAccessorMixin';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { ControlValueAccessorUtils } from '../../../core/utils/ControlValueAccessorUtils';
import { WidthDirective } from '../../directives/width.directive';
import { heightDirective } from '../../directives/height.directive';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [
    WidthDirective,
    heightDirective,
    FormsModule
  ],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ControlValueAccessorUtils.getProvider(StepperComponent)]
})
export class StepperComponent extends ControlValueAccessorMixin<number, BaseComponent>(BaseComponent) {

  @Input() minValue = 1;
  @Input({ required: true }) maxValue: number;
  @Input() step = 1;

  public onValueChange(): void {
    setTimeout(() => {
      if (this.value !== null) {
        if (this.value < this.minValue) {
          this.value = this.minValue;
        } else if (this.value > this.maxValue) {
          this.value = this.maxValue;
        }

        this.cdr.detectChanges();
      }

      this.propagateChanges(this.value);
    });
  }
}
